import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'routerAddressPipe'
})
export class RouterAddressPipe implements PipeTransform {
  transform(value: string, row): string {
    if (row.tunEnabled === false || !value.startsWith('169.254.')) {
      return value;
    }

    const title = 'WebSocket is enabled, please change the Router\'s IP address to its public IP address';

    return `<div class="router-address-pipe">
                ${value}
                <i class="fa fa-warning"
                    title="${title}">
                </i>
            </div>`;
  }
}
